<template>
  <div>
    <div class="search-select">
      <div class="search">
        <!-- 下拉切换审批、抄送 -->
        <van-dropdown-menu class="drop-down"
                           v-if="!isShowSearchBar">
          <van-dropdown-item v-model="dropdownValue"
                             :options="dropdownList"
                             @change="dropDownChange" />
        </van-dropdown-menu>
        <div class="btns">
          <!-- 搜索框 -->
          <form v-if="isShowSearchBar"
                class="search-bar"
                action="/">
            <van-search v-model="searchName"
                        placeholder="请输入申请人/主题"
                        shape="round"
                        show-action
                        @cancel="isShowSearchBar = false"
                        @search="searchFun"
                        @clear="searchFun">
            </van-search>
          </form>
          <!-- 搜索和筛选按钮 -->
          <div class="search-btn flex-center"
               v-if="!isShowSearchBar"
               @click="isShowSearchBar = true">
            <i class="iconfont">&#xe60b;</i>&nbsp;搜索
          </div>
          <div class="select-btn flex-center"
               @click="showSelectCon = !showSelectCon">
            <i class="iconfont">&#xe61d;</i>&nbsp;筛选
          </div>
        </div>
      </div>
      <!-- 筛选组件：时间范围、审批状态 -->
      <office-select-choose v-show="showSelectCon"
                            @submitFun="submitHan"
                            :showSelectStatus="true">
      </office-select-choose>
    </div>
    <van-pull-refresh v-if="total > 0 && !showSelectCon"
                      v-model="isLoading"
                      @refresh="onRefresh">
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">

        <div class="approval-con">
          <office-item v-for="item in list"
                       v-bind:key="item.OfficialDocID"
                       @itemClickHandler="detailView(item)"
                       :nameIcon="item.Icon?item.Icon:''"
                       :name="item.FullName"
                       :officeTitle="item.OfficialDocTitle"
                       :officeTheme="item.OfficialDocTheme"
                       :officeType="item.OfficialDocTypeName"
                       :officeDate="item.CreatedByStrDate"
                       :status="item.Status">
          </office-item>
        </div>
      </van-list>
    </van-pull-refresh>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
  </div>
</template>
<script>
import OfficeSelectChoose from '@/pages/operationalAnalysis/views/official/OfficeSelectChoose'
import OfficeItem from '@/pages/operationalAnalysis/components/OfficeItem'
import NoData from '@/components/noData/Index'

export default {
  name: 'Approval',
  components: {
    OfficeSelectChoose,
    OfficeItem,
    NoData
  },
  data () {
    return {
      imgUrl: this.xyMApi + '/base',
      //是否为审批：审批or抄送
      isApproval: true,

      //list
      isLoading: false,//下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      isRefresh: false,// 是否加载中
      finished: false,// 加载是否完成
      list: [],
      total: 0,
      startTime: "", //开始时间
      endTime: "", //结束时间

      approvalStatus: -1,//审批状态 默认-1
      searchName: '',

      //search
      isShowSearchBar: false,//搜索框展示
      showSelectCon: false,//筛选下拉框展示

      //下拉菜单
      dropdownValue: 0,
      dropdownList: [
        { text: '审批', value: 0 },
        { text: '抄送', value: 1 },
      ],

      //detail
      detailTitle: '公文审批',
      detailModel: false,
      curId: 0,//当前id
    }
  },
  created () {
    this.resetAndLoad();
  },
  mounted () {
  },
  methods: {
    //切换审批和抄送
    dropDownChange (value) {
      if (value === 0) {
        //审批：0
        this.isApproval = true;
      } else if (value === 1) {
        //抄送：1
        this.isApproval = false;
      }
      this.resetAndLoad();
    },
    //list
    async onLoad () {
      let url = '';
      this.xy.loading();
      if (this.isApproval) {
        url = `${this.$store.state.apiPath}/api/OfficialDocument/GetApprovalRecordByPageForMobile`;
      } else {
        url = `${this.$store.state.apiPath}/api/OfficialDocument/GetCCRecordByPageForMobile`;
      }
      let res = await this.xyapi.get(url, {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        searchText: this.searchName,
        status: this.approvalStatus,
        startTime: this.startTime,
        endTime: this.endTime,
        emergencyID: 0,
        secretID: 0,
        typeID: 0
      })
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished = (this.list.length >= res.data.totalRecords) ? true : false
        this.xy.unloading();
      } else {
        this.$toast.fail(res.msg);
        this.xy.unloading();
      }
      // 加载状态结束
      this.isRefresh = false;
    },
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },

    //重置条件
    resetAndLoad () {
      this.pageIndex = 1;
      this.list = [];
      this.onLoad();
    },

    //搜索、清除搜索触发
    searchFun () {
      this.resetAndLoad();
    },

    //监听提交下拉筛选
    submitHan ($event) {
      this.approvalStatus = $event.approvalStatus;
      this.startTime = $event.startTime;
      this.endTime = $event.endTime;
      this.showSelectCon = false;
      setTimeout(() => {
        this.resetAndLoad();
      }, 500);
    },
    //查看明细
    detailView (item) {
      this.$router.push({
        path: '/home/official/detail',
        query: {
          id: item.OfficialDocID,
          type: this.isApproval ? 'approval' : 'copy'//明细为公文流转公文组件，根据不同list判断不同明细细节
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.van-ellipsis {
  font-size: 28px;
  color: #505050;
}
.search {
  display: flex;
  background: #fff;
  height: 100px;
  padding: 0 15px;
  .drop-down {
    flex: 3;
    background: #f3f3f3;
    margin: 14px 20px 14px 0;
    height: 72px;
    border-radius: 6px;
  }
  .btns {
    flex: 2;
    display: flex;
    color: #505050;
    .search-btn {
      flex: 1;
    }
    .search-bar {
      flex: 4;
    }
    .select-btn {
      flex: 1;
    }
  }
}
.approval-con {
  padding: 15px;
}
</style>
